import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import {
  RdsCardModule,
  RdsIconsModule,
  RdsButtonModule,
} from '@rds/angular-components';
import { TeaserCardComponent } from '../../shared/teaser-card/teaser-card.component';
import { OfferingInstallation } from '../../../models/offering';
import { APPLICATION_FORM_TEXTS } from '../../../constants/application-form.constants';

@Component({
  selector: 'inexp-offering-installations',
  imports: [
    RdsCardModule,
    RdsIconsModule,
    RdsButtonModule,
    TeaserCardComponent,
  ],
  templateUrl: './offering-installations.component.html',
  styleUrl: './offering-installations.component.scss',
})
export class OfferingInstallationsComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  router = inject(Router);
  installationInformation = input<OfferingInstallation[]>();
  readonly OFFERING_FORM = APPLICATION_FORM_TEXTS;

}
